import { createApp } from 'vue'
import { sentry } from '@/sentry'
import { createPinia } from 'pinia'
import { createToaster } from '@/plugins/toaster'
import router from './router'
import App from './App.vue'

const app = createApp(App)
const pinia = createPinia()
const toaster = createToaster()

app.use(sentry)
app.use(router)
app.use(toaster)
app.use(pinia)

app.mount('#app')
